import { render } from "./Register.vue?vue&type=template&id=5fb5ac9d"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\Workout-Tracker\\workout-tracker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])